module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p12-13.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('h1', [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("Almost Meatless")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "start3"
  })]), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }), _c('a', {
    attrs: {
      "href": "#/cap01#page15"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("About Meatless Meals")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#page16"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Crafting a Meatless Meal")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#page26"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("GLUTEN-FREE STAPLE"), _c('br'), _vm._v("Socca")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#page38"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("GLUTEN-FREE STAPLE"), _c('br'), _vm._v("Herbed Egg Crepes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#page51"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("GLUTEN-FREE STAPLE"), _c('br'), _vm._v("Polenta Pizza Crust")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#page19"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Polenta, Fried Eggs, Greens, and Blistered Tomatoes")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  })]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }), _c('a', {
    attrs: {
      "href": "#/cap01#page20"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Thai-Style Tofu and Butternut Squash Curry")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#page23"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Mushroom Spaghetti Carbonara")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#page24"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Vegetable and Olive Platter with White Bean Hummus")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#page25"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Asparagus with Burrata and Pistachio Salsa Verde")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#page28"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Crisp Socca with Burrata, Greens, and Olive Dressing")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#page31"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Braised Chickpeas and Carrots with Yogurt Topping")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#page32"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Soft Socca with Summer Squash, Basil, and Gruyère")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#page35"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Penne with Walnut Pesto and Peas")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#page36"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Black Bean and Feta Quesadillas")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#page37"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Soft Polenta with Mushroom Ragout and Poached Eggs")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#page41"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Herbed Egg Crepes with Ricotta and Spring Salad")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#page42"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Grilled Eggplant, Tomatoes, and Goat Cheese")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#page45"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Macaroni and Cheese with Chard and Sage Bread Crumbs")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#page46"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("White Bean, Kale, and Sage Soup")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#page48"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Indian-Style Chickpea Salad")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#page49"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Spaghetti with Heirloom Tomatoes, Olives, and Herbs")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#page52"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Polenta Pizza with Tomatoes and Fresh Herbs")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#page55"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Quinoa Tabbouleh")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#page56"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Potato Pancakes, Poached Eggs, and Green Onion Sauce")])])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p14.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "Recipe-Title"
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("About Meatless Meals")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "Headnote"
  }, [_vm._v("When planning my dinners, I start with fresh produce I find at the farmers’ market and let it inspire the other ingredients I add to my meals. While I love to eat seafood, poultry, and meat, I will just as often choose meatless meals, which fit in well with my produce-driven style of cooking and active lifestyle.")]), _vm._v(" "), _c('p', {
    staticClass: "Technique-Subheads"
  }, [_vm._v("Eating vegetarian (almost)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("While I am not a vegetarian, I enjoy eating plant-based meals often. But from time to time I like to add a little bit of pancetta (unsmoked, Italian-style bacon) to my recipes. I keep it on hand in my refrigerator, as just a little bit goes a long way to flavor and lend substance to a variety of dishes. Chicken broth also helps lend depth to my otherwise vegetarian recipes, but vegetable broth will also work.")]), _vm._v(" "), _c('p', {
    staticClass: "Technique-Subheads"
  }, [_vm._v("Cooking with the seasons")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("Quality vegetables are readily available when I use produce that’s in season. I also like to plan my dinners based on the weather: lighter dishes in the spring and summer and heartier fare when the weather turns cool. For more on ")]), _c('span', {
    attrs: {
      "href": "#/cap06#page206",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("seasonal produce, turn to see recipe")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "Technique-Subheads"
  }, [_vm._v("Planting a kitchen garden")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Fresh herbs are key to my cooking style. They also help keep vegetarian meals exciting. For my first birthday after we started dating, my now-husband Steve gave me an herb garden. He showed up at my house with terra cotta pots, potting soil, and baby herb plants. We planted them together, and they have become both inspirational and a joy to maintain. Now, I can snip fresh herbs whenever I want them. Even if you don’t live in a warm climate, as I do, you can grow herbs in a sunny windowsill.")]), _vm._v(" "), _c('p', {
    staticClass: "Technique-Subheads"
  }, [_vm._v("Storing fresh herbs")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If you don’t have a cutting garden, buy large bunches of parsley, basil, or cilantro and put them in glasses of water to keep on the kitchen counter for snipping as needed. The herbs will stay fresh for several days. Put other herbs such as thyme, marjoram, or rosemary in a plastic bag, seal the bag with some air enclosed, and store in the refrigerator.")]), _vm._v(" "), _c('p', {
    staticClass: "Technique-Subheads"
  }, [_vm._v("Choosing eggs")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Many farmers’ markets offer fresh, recently gathered eggs. I like the deep orange color of the yolks and the satisfaction I get from buying from a local farm. An overlooked choice for dinner, eggs are one of the best quick-cooking ingredients for weeknight meals.")]), _vm._v(" "), _c('p', {
    staticClass: "Technique-Subheads"
  }, [_vm._v("Choosing tofu and beans")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Protein-rich tofu makes a welcome appearance in my cooking. I love how well it soaks up the flavor of the ingredients cooked with it and its meaty, satisfying texture. Tofu comes in varying densities, but I usually buy firm. It is solid enough to hold its shape while cooking, yet still moist in the center. Sold packed in water or in aseptic packaging, tofu should be drained, rinsed, and then drained again before use. I always choose organic canned beans for my weeknight cooking, as I find their flavor and texture to be superior to regular canned beans.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "HeadnoteBox"
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("Nothing inspires me more than wandering my nearby farmers’ market for fresh fruits and vegetables. This seasonal produce informs all of my cooking—especially my meatless meals—where the vibrant colors and flavors really shine through.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  })]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "pagebreak"
  })]), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p17.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "pagebreak"
  })]), _c('p', {
    staticClass: "Recipe-Title"
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("Crafting a meatless meal")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "Headnote"
  }, [_vm._v("When I’m eating vegetarian, it’s essential that the dinner be satisfying enough that I don’t feel deprived. I anchor meatless meals with a starchy gluten-free staple such as pasta, quinoa, potatoes, or polenta, and then add hearty ingredients like eggs, mushrooms, and lots of vegetables to keep meals exciting.")]), _vm._v(" "), _c('p', {
    staticClass: "Technique-Subheads"
  }, [_vm._v("Poaching eggs")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("My favorite way to eat eggs is poached, which I then perch atop a vegetable ragout, polenta, or sautéed greens. Here is my foolproof method for poaching eggs: Fill a large frying pan three-fourths full with salted water and bring to a boil. Add a splash of vinegar. Break an egg into a cup, then slide the egg into the water. Repeat to add the remaining eggs to the pan. Bring the water back to a simmer. Turn off the heat, cover, and let stand until the whites are set, about 2 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "Technique-Subheads"
  }, [_vm._v("Blanching vegetables")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Bring a large pot three-fourths full of water to a boil. Have ready a large bowl of ice water. When the water is boiling, add about 2 teaspoons salt. Add the vegetables to the boiling water. As soon as the vegetables are crisp, barely tender, and brightly colored, after a few seconds, remove them from the water with a skimmer or slotted spoon. Immediately transfer the blanched vegetables to the ice water to stop the cooking and let them stand for a minute or two. Drain and pat the vegetables dry before using in a recipe. For fingerling potatoes, boil them until they are just tender, about 10 minutes. You can skip the ice-water soaking step.")]), _vm._v(" "), _c('p', {
    staticClass: "Technique-Subheads"
  }, [_vm._v("Working with mushrooms")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I love using mushrooms in meatless dishes, as their natural umami and texture is as satisfying as meat. Cleaning them is easy: Using a gentle vegetable brush, gently sweep away any dirt from the mushrooms. Use a damp cloth or paper towel to wipe away any stubborn dirt. Avoid rinsing or soaking mushrooms, or they could get soggy. Using a paring knife, trim a thin slice from the base of each mushroom stem. Some varieties, such as shiitake mushrooms, have tough, woody stems, which should be removed before use.")]), _vm._v(" "), _c('p', {
    staticClass: "Technique-Subheads"
  }, [_vm._v("Cooking gluten-free pasta")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I find that gluten-free pastas have more of a tendency to stick together than regular wheat pastas. It is important to stir gluten-free pastas—particularly long strand pastas like spaghetti and linguine—as soon as they are added to the cooking water and then stir them frequently throughout the cooking process.")]), _vm._v(" "), _c('p', {
    staticClass: "Technique-Subheads"
  }, [_vm._v("Working with quinoa")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This high-protein grain has a natural residue that is very bitter. Rinsing and draining it several times before cooking helps remove this substance, leaving a versatile, mild flavor.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })]), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "pagebreak"
  })]), _c('p', {
    staticClass: "Recipe-Title"
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("Polenta, Fried Eggs, Greens, and Blistered Tomatoes")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "Headnote"
  }, [_vm._v("Creamy polenta topped with fried eggs, sautéed greens, and cherry tomatoes cooked until they burst is much better than eggs with toast. This is the dish I used to convince my husband that eggs make a great dinner.")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Olive oil")]), _vm._v(", 2 tablespoons")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cherry or grape tomatoes")]), _vm._v(", 2 cups (12 oz/375 g)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Red onion, ½")]), _vm._v(" cup (3 oz/90 g) minced")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Red pepper flakes")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chard")]), _vm._v(", 1 large bunch, stems removed, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Kosher salt and freshly ground pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Large eggs")]), _vm._v(", 4")])]), _c('p', {
    staticClass: "Ingredients"
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }), _c('span', {
    attrs: {
      "href": "#/cap03#page115",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Creamy Weeknight Polenta")]), _vm._v(" (see recipe)")]), _vm._v(", using thyme")]), _vm._v(" "), _c('p', {
    staticClass: "Serves"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 2 SERVINGS")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colg"
  }, [_vm._v("1")])]), _vm._v("    In a large nonstick frying pan over medium-high heat, warm the oil. Add the tomatoes and cook, stirring occasionally, until blistered, about 4 minutes. Transfer to a bowl. Add the onion and a pinch of pepper flakes to the pan and sauté for 1 minute to soften slightly. Add the chard and sprinkle with salt and black pepper, and stir for 1 minute to coat with oil. Add "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("¼")]), _vm._v(" cup (2 fl oz/60 ml) water and cook, stirring frequently, until the chard is tender, about 5 minutes. Return the tomatoes to the frying pan and stir for 1 minute to warm. Reduce the heat to medium-low.")]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colg"
  }, [_vm._v("2")])]), _vm._v("    Using a wooden spoon, make 4 indentations in the mixture. Break an egg into each indentation and sprinkle with salt and black pepper. Cover the pan and cook until the egg whites are set, about 4 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colg"
  }, [_vm._v("3")])]), _vm._v("    Divide the polenta between 2 warmed plates, spreading it over the center of the plates in a circle. Use a spatula to transfer the eggs and vegetables around them to the plates, arranging atop the polenta. Serve right away.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "HeadnoteBox"
  }, [_vm._v("Begin the polenta first, and it will be ready to add the herbs and cheese while the eggs are cooking.")])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p21.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "pagebreak"
  })]), _c('p', {
    staticClass: "Recipe-Title"
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("Thai-Style Tofu and Butternut Squash Curry")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "Headnote"
  }, [_vm._v("Creamy and spicy, this intensely flavored dish is based on the pumpkin curry at a local, beachside Thai restaurant. It is naturally gluten-free, the rich texture coming from coconut milk rather than flour.")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Vegetable oil")]), _vm._v(", 1 tablespoon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Green onions")]), _vm._v(", 4, white and light green parts sliced separately")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fresh ginger")]), _vm._v(", 3 tablespoons minced")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Butternut squash cubes")]), _vm._v(", 1 package ("), _c('span', {
    staticClass: "bold"
  }, [_vm._v("¾")]), _vm._v("–1 lb/375–500 g)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Coconut milk")]), _vm._v(", 1 can (14 oz/430 ml)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fresh lime juice")]), _vm._v(", 2 tablespoons")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Asian fish sauce or gluten-free tamari")]), _vm._v(", 1"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("½")]), _vm._v(" tablespoons")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Thai red curry paste")]), _vm._v(", 1 tablespoon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Sugar")]), _vm._v(", 2 teaspoons")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Firm tofu")]), _vm._v(", 1 package (14 oz/440 g) drained, cut into "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("¾")]), _vm._v("-inch pieces")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chard leaves")]), _vm._v(", 2 cups (2 oz/60 g) chopped")])]), _c('p', {
    staticClass: "Ingredients"
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }), _c('span', {
    attrs: {
      "href": "#/cap07#page214",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Brown jasmine rice")]), _vm._v(" (see recipe)")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fresh basil, ⅓")]), _vm._v(" cup ("), _c('span', {
    staticClass: "bold"
  }, [_vm._v("½")]), _vm._v(" oz/15 g), sliced")]), _vm._v(" "), _c('p', {
    staticClass: "Serves"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 4 SERVINGS")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colo"
  }, [_vm._v("1")])]), _vm._v("    In a heavy medium pot over medium-low heat, warm the oil. Add the white part of the green onions and the ginger and stir until fragrant, about 2 minutes. Add the squash and stir 1 minute to heat. Add the coconut milk, "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("¾")]), _vm._v(" cup (6 fl oz/180 ml) water, lime juice, fish sauce, curry paste, and sugar and bring to a simmer. Stir in the tofu. Cover partially and simmer until the squash is just tender, about 20 minutes. Add the chard and cook until wilted, about 2 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colo"
  }, [_vm._v("2")])]), _vm._v("    Fluff the rice with a fork and divide among 4 warmed bowls. Spoon the curry over. Sprinkle with the green part of the green onions and the basil and serve right away.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "HeadnoteBox"
  }, [_vm._v("For convenience, I use a package of precut butternut squash; if it is unavailable, peel and cut enough squash to measure 2"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("½")]), _vm._v(" cups (about 12 oz/375 g).")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "HeadnoteBox"
  }, [_vm._v("I love the nuttiness of brown jasmine rice, and it cooks in the same times as it takes to make the curry.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "HeadnoteBox"
  }, [_vm._v("Use this as a basic recipe, substituting broccoli rabe or kale for the chard, or scallops or cubes of your favorite fish for the tofu.")])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p22.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "pagebreak"
  })]), _c('p', {
    staticClass: "Recipe-Title"
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("Mushroom Spaghetti Carbonara")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "Headnote"
  }, [_vm._v("Here, mushrooms and pasta are cloaked in a creamy, sage-flecked egg and cheese sauce, with a shower of fresh basil. I like it with a little pancetta, but you can replace it with olive oil for a strictly vegetarian dish.")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Pancetta")]), _vm._v(", 1"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("½")]), _vm._v(" oz (45 g), chopped, or 1 tablespoon olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cremini mushrooms, ½")]), _vm._v(" lb (250 g), sliced")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Onion, ½")]), _vm._v(", finely diced")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fresh sage")]), _vm._v(", 1 tablespoon minced")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Red pepper flakes")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Kosher salt and freshly ground pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Gluten-free spaghetti")]), _vm._v(", 6 oz (185 g)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Large eggs")]), _vm._v(", 2")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Parmesan cheese, ¾")]), _vm._v(" cup (3 oz/85 g) freshly grated")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Dry white wine, ¼")]), _vm._v(" cup (2 fl oz/60 ml)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fresh flat-leaf parsley or basil leaves, ¼")]), _vm._v(" cup ("), _c('span', {
    staticClass: "bold"
  }, [_vm._v("⅓")]), _vm._v(" oz/10 g) torn")]), _vm._v(" "), _c('p', {
    staticClass: "Serves"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 2 SERVINGS; CAN BE DOUBLED")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colg"
  }, [_vm._v("1")])]), _vm._v("    Place a large nonstick frying pan over medium-high heat. Add the pancetta and sauté until beginning to brown, about 3 minutes. Add the mushrooms, onion, sage, and a pinch of pepper flakes. Sprinkle with salt and a generous amount of black pepper. Sauté until the mushrooms are tender, about 8 minutes. Remove the frying pan from the heat.")]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colg"
  }, [_vm._v("2")])]), _vm._v("    Add the pasta to a large pot of boiling salted water and stir well. Cook, stirring frequently, until al dente, about 8 minutes. Meanwhile, in a small bowl, beat the eggs with a fork and mix in the cheese.")]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colg"
  }, [_vm._v("3")])]), _vm._v("    Remove "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("½")]), _vm._v(" cup (4 fl oz/125 ml) of the pasta cooking water and reserve. Drain the pasta. Add the wine to the frying pan with the mushroom mixture and boil until reduced by half, stirring up the browned bits, about 1 minute. Remove the pan from the heat. Add the spaghetti to the frying pan. Gradually whisk "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("¼")]), _vm._v(" cup (60 ml) of the reserved pasta cooking liquid into the egg mixture. Add the egg mixture to the frying pan and stir until it coats the pasta and is creamy, not wet and runny. If the egg mixture does not become creamy, set the frying pan over very low heat and stir constantly just until it becomes creamy, watching carefully (do not boil).")]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colg"
  }, [_vm._v("4")])]), _vm._v("    Immediately remove the frying pan from the heat. If needed, mix in enough of the remaining "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("¼")]), _vm._v(" cup (60 ml) pasta cooking liquid to form a silky texture. Divide between 2 warmed bowls and serve right away.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "HeadnoteBox"
  }, [_vm._v("Gluten-free pasta tends to be stickier than wheat pasta and therefore needs to be stirred thoroughly when first added to the pot of boiling water, and then frequently while cooking.")])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })]), _c('p', {
    staticClass: "Recipe-Title"
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("Vegetable and Olive Platter with White Bean Hummus")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "Headnote"
  }, [_vm._v("Dipping ingredients in hummus is so satisfying; I like to use it as the focal point for an entire meal. With carrots, fennel, tomatoes, and multigrain tortilla chips or socca to scoop it, you won’t miss pita bread.")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Thin-skinned boiling potatoes")]), _vm._v(", ("), _c('span', {
    staticClass: "bold"
  }, [_vm._v("¾")]), _vm._v(" lb/375 g) cut lengthwise into 1-inch (2.5 cm) wide wedges")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Shallot")]), _vm._v(", 1 large, or 2 small garlic cloves, roughly chopped")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cannellini beans")]), _vm._v(", 2 cans (15 oz/ 470 g each), rinsed and drained")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Tahini, ½")]), _vm._v(" cup (5 oz/150 g)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fresh lemon juice, ½")]), _vm._v(" cup (4 fl oz/125 ml)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Extra-virgin olive oil, ¼")]), _vm._v(" cup (2 fl oz/60 ml)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chile powder")]), _vm._v(", 1"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("½")]), _vm._v(" teaspoons")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fresh dill, ⅓")]), _vm._v(" cup ("), _c('span', {
    staticClass: "bold"
  }, [_vm._v("½")]), _vm._v(" oz/15 g) minced")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Kosher salt and freshly ground pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Lettuce leaves")]), _vm._v(", such as romaine, little gem, or butter lettuce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Carrots")]), _vm._v(", 1 bunch, peeled and cut into 2-inch (5-cm) pieces")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Large fennel bulb")]), _vm._v(", 1, trimmed and sliced")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cherry tomatoes")]), _vm._v(", 1 pint (12 oz/375 g)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Lucques or Kalamata olives, ⅓")]), _vm._v(" cup (4 oz/120 g)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Feta cheese")]), _vm._v(", 3 oz (90 g), cut into "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("¾")]), _vm._v("-inch (2-cm) chunks")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Gluten-free multigrain tortilla chips")]), _vm._v(" (I like Food Should Taste Good chips)")]), _vm._v(" "), _c('p', {
    staticClass: "Serves"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 4 SERVINGS")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colb"
  }, [_vm._v("1")])]), _vm._v("    Steam the potato wedges over boiling water until just tender, about 15 minutes. Let cool while preparing the hummus.")]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colb"
  }, [_vm._v("2")])]), _vm._v("    In a food processor, mince the shallot. Add the cannellini beans, tahini, lemon juice, oil, and chile powder and puree until smooth. Add enough water to thin to the consistency of thick mayonnaise. Mix in the dill. Season to taste with salt and pepper. Transfer to a small bowl.")]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colb"
  }, [_vm._v("3")])]), _vm._v("    Line a platter with lettuce leaves. Place the bowl of hummus in the center. Arrange the potatoes, carrots, fennel, tomatoes, olives, and cheese in mounds around the hummus. Serve with the tortilla chips.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "HeadnoteBox"
  }, [_vm._v("Tahini, a peanut butter-like paste made from ground sesame seeds, is available near the peanut butter in some supermarkets, at natural food stores, and in Middle Eastern stores. Stir it thoroughly before using.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "HeadnoteBox"
  }, [_vm._v("This makes a generous quantity of hummus, so that there is extra to enjoy as a satisfying snack or appetizer another day.")])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })]), _c('p', {
    staticClass: "Recipe-Title"
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("Asparagus with Burrata and Pistachio Salsa Verde")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "Headnote"
  }, [_vm._v("Inspired by a dish at a favorite restaurant, the creamy cheese topped with a fresh herb sauce is punctuated with crunchy nuts and is so satisfying; I also adore the sauce on grilled seafood, especially salmon, or chicken.")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Extra-virgin olive oil")]), _vm._v(", 6 tablespoons (3 fl oz/90 ml)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fresh basil, ¼")]), _vm._v(" cup ("), _c('span', {
    staticClass: "bold"
  }, [_vm._v("⅓")]), _vm._v(" oz/10 g) finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Toasted salted pistachio nuts, ¼")]), _vm._v(" cup (1 oz/30 g) finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Shallot")]), _vm._v(", 2 tablespoons minced")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Lemon zest")]), _vm._v(", grated from "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("½")]), _vm._v(" lemon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Kosher salt and freshly ground pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Asparagus")]), _vm._v(", 2 large bunches (about 1"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("½")]), _vm._v(" lb/750 g total), ends trimmed")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Burrata cheese")]), _vm._v(", two 4-oz (125-g) balls")]), _vm._v(" "), _c('p', {
    staticClass: "Serves"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 4 SERVINGS")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colb"
  }, [_vm._v("1")])]), _vm._v("    In a small bowl, mix the oil, basil, pistachio nuts, shallot, and lemon zest. Season to taste with salt and pepper.")]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colb"
  }, [_vm._v("2")])]), _vm._v("    Bring a large frying pan three-fourths full of salted water to a boil. Add the asparagus, cover, and boil until the asparagus is just tender, 4–8 minutes, depending on the thickness of the asparagus. Drain well.")]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colb"
  }, [_vm._v("3")])]), _vm._v("    Divide the asparagus among 4 warmed plates. Cut each ball of burrata in half and place one half atop the asparagus on each plate, arranging it cut side up. Spoon the salsa verde over the burrata and asparagus and serve right away.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "HeadnoteBox"
  }, [_vm._v("One Sunday morning, I replaced the burrata here with poached eggs for a memorable brunch.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "HeadnoteBox"
  }, [_vm._v("I buy burrata in an 8-ounce (250-g) container, which contains two 4-ounce (125-g) cheese balls.")])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })]), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p26-27.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "pagebreak"
  })]), _c('p', {
    staticClass: "Recipe-Title"
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("Socca")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "Headnote"
  }, [_vm._v("Popular in Provence, socca is a naturally gluten-free flatbread made from chickpea flour. It can be served on its own as a side dish or accompaniment to a meal. The crisp version (right) can be topped with cheese or salad. The soft version can be topped with your favorite ingredients and eaten like a pizza or wrapped around a filling and enjoyed like a burrito.")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chickpea (garbanzo bean) flour")]), _vm._v(", 1 cup (4 oz/125 g) for crisp socca or 1"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("¾")]), _vm._v(" cups (7 oz/220 g) for soft socca")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Olive oil")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fresh rosemary")]), _vm._v(", 1"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("½")]), _vm._v(" teaspoons minced")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Kosher salt and freshly ground pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "Technique-Subheads"
  }, [_vm._v("Crisp Socca")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a bowl, combine the 1 cup (4 oz/125 g) flour, 1 cup (8 fl oz/250 ml) room temperature water, 2 tablespoons olive oil, the rosemary, "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("¾")]), _vm._v(" teaspoon salt, and a generous amount of pepper. Whisk until smooth. Use right away or cover and let stand at room temperature for 30 minutes to 2 hours, or refrigerate overnight.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Arrange the rack in the top part of the oven and preheat to 500°F (260°C). After the oven is fully heated, turn on the broiler, place two 9-inch cake pans in the oven, and heat for 2 minutes. Carefully remove the hot pans from the oven, pour 1 tablespoon oil into each, and swirl to coat the bottoms. Return the pans to the oven until the oil is just smoking, about 2 minutes longer. Carefully remove the pans from the oven and divide the batter between the pans, swirling to cover. Broil until the socca are firm and deeply browned in spots, watching carefully, 7–12 minutes. Serve right away. Makes 2 crisp socca.")]), _vm._v(" "), _c('p', {
    staticClass: "Technique-Subheads"
  }, [_vm._v("Soft Socca")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a bowl, combine 2 cups (16 fl oz/500 ml) water, the 1"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("¾")]), _vm._v(" cups (7 oz/220 g) flour, 1"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("½")]), _vm._v(" tablespoons oil, the rosemary, "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("¾")]), _vm._v(" teaspoon salt, and a generous amount of pepper. Whisk until smooth. Preheat the oven to 325°F (165° C). Line 2 large baking sheets with parchment paper and brush lightly with oil. Lightly brush a 10-inch (25-cm) nonstick frying pan (with a 7"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("½")]), _vm._v("-inch/19-cm base) with oil and warm over medium-high heat until very hot. Add about one-fourth of the batter and swirl to coat the pan. Cook until air bubbles appear on the top and the bottom is brown, about 2 minutes. Using a silicone spatula, turn the socca over and cook until spotted brown on the bottom, about 1 minute longer. Turn over onto the parchment. Repeat to cook the remaining batter, forming 4 total. Bake for 5 minutes to cook through and serve, or arrange toppings on socca and bake according to the recipe directions. Makes 4 soft socca.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })]), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p29.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "pagebreak"
  })]), _c('p', {
    staticClass: "Recipe-Title"
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("Crisp Socca with Burrata, Greens, and Olive Dressing")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "Headnote"
  }, [_vm._v("I discovered that socca, a chickpea-based flatbread, makes a wonderful base for creamy burrata cheese. The batter can be whisked together and used right away, but it’s even better if it stands for at least 30 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Pitted Kalamata olives, ¼")]), _vm._v(" cup (1 oz/30 g)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Extra-virgin olive oil, ⅓")]), _vm._v(" cup (3 fl oz/80 ml)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Red wine vinegar")]), _vm._v(", 2 tablespoons")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Freshly ground pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Arugula or baby greens")]), _vm._v(", 4 cups (about 4 oz/120 g)")])]), _c('p', {
    staticClass: "Ingredients"
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }), _c('a', {
    attrs: {
      "href": "#/cap01#page26"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Crisp Socca")]), _vm._v(" (see recipe)")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Burrata cheese")]), _vm._v(", two 4-oz (125-g) balls")]), _vm._v(" "), _c('p', {
    staticClass: "Serves"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 2 SERVINGS")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colo"
  }, [_vm._v("1")])]), _vm._v("    Place the olives in a food processor and process until finely chopped. Add the oil and vinegar and process to blend to make a dressing. Season to taste with pepper (the olives probably contain enough salt already).")]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colo"
  }, [_vm._v("2")])]), _vm._v("    Place the arugula in a large bowl. Add half of the dressing and toss to coat the leaves well.")]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colo"
  }, [_vm._v("3")])]), _vm._v("    Turn the browned socca out onto 2 plates. Slice the burrata and spread over the socca. Drizzle with the remaining dressing, and then top with the dressed greens and serve right away.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "HeadnoteBox"
  }, [_vm._v("Prepare the dressing and dress the salad while the socca is cooking. It will be ready when you turn out the socca onto plates for serving.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "HeadnoteBox"
  }, [_vm._v("If you can, make the batter the night before or first thing in the morning, and store it in the refrigerator. It will be ready for a quick meal at the end of the day.")])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p30.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "pagebreak"
  })]), _c('p', {
    staticClass: "Recipe-Title"
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("Braised Chickpeas and Carrots with Yogurt Topping")])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "Headnote"
  }, [_vm._v("Tender beans and sweet carrots are infused with enticing spices, and get a dollop of an Indian-inspired yogurt topping. White quinoa is a great substitute for couscous, and it is very high in protein.")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Slender carrots")]), _vm._v(", 1 lb (500 g), unpeeled")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Olive oil")]), _vm._v(", 4 tablespoons (2 fl oz/60 ml) plus 1"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("½")]), _vm._v(" teaspoons")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Large onion")]), _vm._v(", 1, coarsely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Sweet paprika")]), _vm._v(", 2 teaspoons")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ground cumin")]), _vm._v(", 1 teaspoon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ground cinnamon and ginger, ½")]), _vm._v(" teaspoon "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("each")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cayenne pepper, ¼")]), _vm._v(" teaspoon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chickpeas")]), _vm._v(", 2 cans (15 oz/470 g each), rinsed and drained")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Diced tomatoes with juices")]), _vm._v(", 2 cans (14.5 oz/455 g each)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Raisins")]), _vm._v(", 1 cup (6 oz/185 g)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Kosher salt and freshly ground black pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Quinoa")]), _vm._v(", 1"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("½")]), _vm._v(" cups (9 oz/92 g)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Plain Greek-style yogurt, ½")]), _vm._v(" cup (4 oz/125 g)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fresh cilantro leaves and toasted sliced almonds for garnish")])]), _vm._v(" "), _c('p', {
    staticClass: "Serves"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 4 SERVINGS")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colb"
  }, [_vm._v("1")])]), _vm._v("    Halve the carrots lengthwise and then quarter them crosswise. In a large nonstick frying pan over medium heat, warm 2 tablespoons of the oil. Add the onion and carrots and sauté until the onion is tender, about 5 minutes. Add the paprika, cumin, cinnamon, ginger, and cayenne and stir for 10 seconds. Add the chickpeas, tomatoes with juices, raisins, and 1 cup (8 fl oz/250 ml) water. Sprinkle with salt and black pepper. Bring to a boil, reduce the heat, cover, and simmer until the carrots are just tender, about 20 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colb"
  }, [_vm._v("2")])]), _vm._v("    Rinse and drain the quinoa 4 times, and then place in a saucepan. Add 2"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("¼")]), _vm._v(" cups (18 fl oz/560 ml) water and a pinch of salt and bring to a boil. Reduce the heat to low, cover, and simmer until all the water is absorbed, about 15 minutes. Turn off the heat and let stand for at least 5 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colb"
  }, [_vm._v("3")])]), _vm._v("    In a small bowl, mix the yogurt and 1 tablespoon of the oil. Season to taste with salt and black pepper. Fluff the quinoa with a fork, and then mix in the remaining 1 tablespoon plus 1"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("½")]), _vm._v(" teaspoons oil.")]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colb"
  }, [_vm._v("4")])]), _vm._v("    Divide the quinoa among warmed plates. Season the chickpea mixture to taste with salt and black pepper and spoon over the quinoa. Spoon the yogurt on top. Sprinkle with cilantro and almonds and serve right away.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "HeadnoteBox"
  }, [_vm._v("For the topping, choose the yogurt you like best—whole milk, two percent, or fat free. No side dish is needed for this complete dish.")])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })]), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page31"
    }
  }), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p33.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('p', {
    staticClass: "pagebreak"
  })]), _c('p', {
    staticClass: "Recipe-Title"
  }, [_c('a', {
    attrs: {
      "id": "page33"
    }
  }), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("Soft Socca with Summer Squash, Basil, and Gruyère")])]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('p', {
    staticClass: "Headnote"
  }, [_vm._v("At my first dinner in a restaurant with a gluten-free menu, socca pizza was featured, and I was thrilled with this use of the flatbread. The versatile wrapper is pleasantly soft and is easy to put together.")])]), _c('p', {
    staticClass: "Ingredients"
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }), _c('a', {
    attrs: {
      "href": "#/cap01#page26"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Soft Socca")]), _vm._v(" (see recipe)")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Olive oil")]), _vm._v(", 1"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("½")]), _vm._v(" tablespoons")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Red pepper flakes, ½")]), _vm._v(" teaspoon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Yellow squash or zucchini")]), _vm._v(", 1 lb (500 g), sliced")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Red onion")]), _vm._v(", 1"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("½")]), _vm._v(" cups (9 oz/280 g) minced")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Kosher salt and freshly ground black pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Balsamic vinegar")]), _vm._v(", 1 tablespoon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Aged Gruyère or Comté cheese")]), _vm._v(", 2"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("½")]), _vm._v(" cups (about 7 oz/220 g) coarsely grated")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fresh basil, ⅓")]), _vm._v(" cup ("), _c('span', {
    staticClass: "bold"
  }, [_vm._v("½")]), _vm._v(" oz/15 g) chopped")]), _vm._v(" "), _c('p', {
    staticClass: "Serves"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 4 SERVINGS")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colo"
  }, [_vm._v("1")])]), _vm._v("    Preheat the oven to 325°F (165°C). Prepare the socca according to the recipe. Meanwhile, in a large nonstick skillet over medium-high heat, warm the oil. Add the pepper flakes and then the squash and red onion. Sprinkle with salt and black pepper. Sauté until the squash is tender-crisp, about 5 minutes. Add the vinegar and stir until evaporated. Remove from the heat. Taste and adjust the seasoning.")]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colo"
  }, [_vm._v("2")])]), _vm._v("    Remove the socca from the oven, and sprinkle the cheese over. Divide the squash mixture among the socca. Return to the oven and cook until the cheese melts, about 4 minutes. Transfer 1 socca to each of 4 warmed plates. Sprinkle with basil and serve right away.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "HeadnoteBox"
  }, [_vm._v("Vary the topping, as you like: Gouda cheese with sautéed Portobello mushrooms and thinly sliced radicchio; or Gorgonzola cheese and caramelized onions are two I like.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "HeadnoteBox"
  }, [_vm._v("Without a topping, the socca can replace flour tortillas or bread, or wedges can be used to scoop up hummus.")])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p34.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('p', {
    staticClass: "pagebreak"
  })]), _c('p', {
    staticClass: "Recipe-Title"
  }, [_c('a', {
    attrs: {
      "id": "page34"
    }
  }), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("Penne with Walnut Pesto and Peas")])]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_c('p', {
    staticClass: "Headnote"
  }, [_vm._v("There was no way I was going to give up pasta with pesto sauce, bursting with fresh basil, when I went gluten-free, so I sought out great gluten-free pastas. This all-purpose sauce is also good over chicken or fish.")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fresh basil leaves")]), _vm._v(", 2 cups (2 oz/60 g) packed")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Shallots")]), _vm._v(", 2, or 1 garlic clove, coarsely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Walnuts, ¼")]), _vm._v(" cup (1 oz/30 g)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Lemon zest")]), _vm._v(", 2 teaspoons finely grated")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Kosher salt and freshly ground pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Extra-virgin olive oil, ¼")]), _vm._v(" cup (2 fl oz/60 ml)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Pecorino romano cheese, ¼")]), _vm._v(" cup (1 oz/30 g) freshly grated, plus more as needed")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Gluten-free penne pasta, ½")]), _vm._v(" lb (250 g)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Sugar snap peas")]), _vm._v(", 10 oz (315 g), strings removed")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Shelled English peas")]), _vm._v(", 10 oz (315 g), or 1 package (10-oz/310 g) frozen peas")]), _vm._v(" "), _c('p', {
    staticClass: "Serves"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 4 SERVINGS")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colg"
  }, [_vm._v("1")])]), _vm._v("    In a food processor, combine the basil, shallots, walnuts, lemon zest, and "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("½")]), _vm._v(" teaspoon salt. Process until finely ground. With the machine running, gradually add the oil. Mix in "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("¼")]), _vm._v(" cup (1 oz/30 g) of the cheese. Season to taste with salt and a generous amount of pepper.")]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colg"
  }, [_vm._v("2")])]), _vm._v("    Add the pasta to a large pot of boiling salted water and stir well. Cook, stirring occasionally, for about 5 minutes (or 4 minutes less than the cooking time indicated on the package). Add the sugar snaps and peas and cook until the pasta is al dente, stirring occasionally, about 4 minutes longer.")]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colg"
  }, [_vm._v("3")])]), _vm._v("    Remove "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("¾")]), _vm._v(" cup (6 fl oz/180 ml) of the pasta cooking water and reserve. Drain the pasta and peas. Put the pesto in a large bowl. Whisk in enough of the reserved cooking water to thin to a sauce. Add the pasta and vegetables and toss to coat. Thin with more cooking liquid and season with salt if needed. Serve right away, passing additional cheese alongside.")])]), _c('div', {
    staticClass: "box"
  }, [_c('a', {
    attrs: {
      "id": "page35"
    }
  }), _c('p', {
    staticClass: "HeadnoteBox"
  }, [_c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("Experiment with the many different types and shapes of gluten-free pastas available today to discover your favorite. Look for a list of my favorite ")]), _c('span', {
    attrs: {
      "href": "#/cap08#page217",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("gluten-free pastas on see recipe")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "Recipe-Title"
  }, [_c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_vm._v("Black Bean and Feta Quesadillas")])]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_c('p', {
    staticClass: "Headnote"
  }, [_vm._v("These quesadillas feature gluten-free corn tortillas instead of the usual wheat flour wrappers. A fresh corn and tomato salsa adds vibrant color and bright flavors. It’s an incredibly quick meal to put together.")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Olive oil")]), _vm._v(", 2 tablespoons, plus more as needed")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Corn kernels")]), _vm._v(" from 1 large ear corn")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Kosher salt and freshly ground pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Tomato")]), _vm._v(", 1, seeded and chopped")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Red onion")]), _vm._v(", 3 tablespoons plus "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("½")]), _vm._v(" cup (3 oz/90 g) minced")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fresh cilantro")]), _vm._v(", 3 tablespoons minced")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fresh lime juice")]), _vm._v(", 1 tablespoon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Serrano chile, ½")]), _vm._v(" small, seeded and minced")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Anise seed, ⅛")]), _vm._v(" teaspoon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Black beans")]), _vm._v(", 1 can (15 oz/470 g) drained, liquid reserved")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Gluten-free corn tortillas")]), _vm._v(", 6 (5"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("½")]), _vm._v("–6 inches/14–15 cm in diameter)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Feta cheese, ¾")]), _vm._v(" cup (about 3 oz/90 g) crumbled")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Radishes")])]), _vm._v(" "), _c('p', {
    staticClass: "Serves"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 2 SERVINGS; CAN BE DOUBLED")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colo"
  }, [_vm._v("1")])]), _vm._v("    In a large nonstick frying pan over medium-high heat, warm 1 tablespoon of the oil. Add the corn and sprinkle with salt and black pepper. Sauté until just tender-crisp, about 1 minute. Transfer to a bowl. Mix in the tomato, the 3 tablespoons onion, cilantro, lime juice, and chile. Season to taste.")]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colo"
  }, [_vm._v("2")])]), _vm._v("    In the same frying pan, warm 1 tablespoon oil over medium-high heat. Add the remaining "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("½")]), _vm._v(" cup (3 oz/90 g) onion and the anise seed and sauté until the onion starts to soften, about 2 minutes. Mix in the drained beans. Simmer, mashing the beans with a spoon to a coarse purée and adding reserved bean liquid if dry. Remove from the heat and season to taste.")]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colo"
  }, [_vm._v("3")])]), _vm._v("    Heat a griddle or large frying pan over medium-low heat. Brush with olive oil. Add 2 tortillas and cook until softened slightly, about 30 seconds. Turn the tortillas over. Spread 2 tablespoons of the bean mixture over half of each tortilla, leaving a border around the edges. Sprinkle with 2 tablespoons of the cheese. Fold the empty side of the tortillas over the filling and press slightly. Cook until light golden and crisp, about 3 minutes on each side. Transfer to warmed plates. Repeat with the remaining beans and cheese, adding more oil as needed. Divide the quesadillas between warmed plates. Serve right away with the corn salsa for topping and radishes for nibbling.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "HeadnoteBox"
  }, [_vm._v("I like to season black beans with a pinch of anise seed, which mimics the subtle taste of wild avocado leaves often used in authentic Mexican cooking.")])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })]), _c('p', {
    staticClass: "Recipe-Title"
  }, [_c('a', {
    attrs: {
      "id": "page36"
    }
  }), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_vm._v("Soft Polenta with Mushroom Ragout and Poached Eggs")])]), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_c('p', {
    staticClass: "Headnote"
  }, [_vm._v("I loved polenta from the moment I first tasted it in Italy, but never so much as since adopting a gluten-free diet. Here it is a creamy base for mushrooms simmered with shallots, thyme, and wine, and tender poached eggs.")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Olive oil")]), _vm._v(", 2 tablespoons")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cremini mushrooms")]), _vm._v(", 10 oz (315 g), sliced")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Shiitake mushrooms")]), _vm._v(", 3–4 oz (90–125 g) stemmed, thickly sliced")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Kosher salt and freshly ground pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Shallots")]), _vm._v(", 2, minced")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fresh thyme")]), _vm._v(", 1 tablespoon minced, plus more for garnish")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Dry white wine, ⅓")]), _vm._v(" cup (3 fl oz/80 ml)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Tomato paste")]), _vm._v(", 1 teaspoon")])]), _c('p', {
    staticClass: "Ingredients"
  }, [_c('a', {
    attrs: {
      "id": "page37"
    }
  }), _c('span', {
    attrs: {
      "href": "#/cap03#page115",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Creamy Weeknight Polenta")]), _vm._v(" (see recipe)")]), _vm._v(", using thyme")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#page16"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Poached Eggs")]), _vm._v(" (see recipe)")]), _vm._v(", 2 or 4")]), _vm._v(" "), _c('p', {
    staticClass: "Serves"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 2 SERVINGS; CAN BE DOUBLED")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colo"
  }, [_vm._v("1")])]), _vm._v("    In a large nonstick frying pan over medium-high heat, warm the oil. Add the cremini and shiitake mushrooms and sprinkle with salt and pepper. Sauté until starting to soften, about 3 minutes. Add 3 tablespoons of the shallots and the 1 tablespoon thyme and sauté for 2 minutes. Add the wine and tomato paste and simmer until the liquid becomes syrupy, 1–2 minutes. Adjust the seasoning. Cover and keep warm.")]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colo"
  }, [_vm._v("2")])]), _vm._v("    Prepare the polenta, adding the remaining shallots to the bowl before cooking. While the polenta cooks, poach the eggs.")]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colo"
  }, [_vm._v("3")])]), _vm._v("    Divide the polenta between 2 warmed plates, spreading in a circle. Spoon the mushrooms over the polenta. Using a slotted spoon, remove the eggs from the poaching water one at a time, drain off any water, and set atop the mushrooms. Sprinkle the eggs with thyme and pepper and serve right away.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "HeadnoteBox"
  }, [_vm._v("For an even quicker dish, or if I don’t have eggs on hand, I replace them with grated Gruyère or crumbled Gorgonzola cheese sprinkled over the mushrooms.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "HeadnoteBox"
  }, [_vm._v("There used to be concerns that blue cheeses contained gluten because the molds used to make them were grown on bread. Today, Gorgonzola and some other blue cheeses have been tested and are gluten free.")])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p38-39.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "Recipe-Title"
  }, [_c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_vm._v("Herbed Egg Crepes")])]), _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_c('p', {
    staticClass: "Headnote"
  }, [_vm._v("As soon as I saw the photo for thin omelets in Yotam Ottolenghi’s book, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Plenty")]), _vm._v(", I was certain they would make a great replacement for crepes. The ones I came up with here are so thin, they resemble crepes, but use no flour, and are wonderfully delicate. You can fill them with almost anything you like; see my favorite fillings at right. To fill the crepes, spread or layer the fillings over half of each crepe. Fold the other half of the crepe over the filling, and then fold them in half again, forming fan shapes. Heat in a 325°F (165°C) oven for about 5 minutes to warm the filling, or serve at room temperature.")])]), _c('p', {
    staticClass: "Ingredients"
  }, [_c('a', {
    attrs: {
      "id": "page38"
    }
  }), _c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Large eggs")]), _vm._v(", 6")])]), _c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Milk, ¼")]), _vm._v(" cup (2 fl oz/60 ml)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Green onions")]), _vm._v(", 4, minced")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Mixed fresh herbs")]), _vm._v(", such as flat-leaf parsley, thyme, and tarragon, "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("½")]), _vm._v(" cup ("), _c('span', {
    staticClass: "bold"
  }, [_vm._v("¾")]), _vm._v(" oz/20 g) minced")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Kosher salt and freshly ground pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Olive oil")]), _vm._v(", 1 teaspoon, plus more as needed")]), _vm._v(" "), _c('p', {
    staticClass: "Serves"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 4 CREPES; 2 SERVINGS")])]), _vm._v(" "), _c('p', {
    staticClass: "Method"
  }, [_vm._v("In a medium bowl, combine the eggs, milk, green onions, mixed herbs, and a pinch each of salt and pepper. Beat with a fork to blend.")]), _vm._v(" "), _c('p', {
    staticClass: "Method"
  }, [_vm._v("Brush a baking sheet with oil. Heat 1 teaspoon oil in a 10-inch (25-cm) nonstick skillet over medium-high heat. Reduce the heat to medium. Add one-fourth of the egg mixture, tipping the pan to cover. Cook until the top of the crepe is set, tipping the pan and spreading the uncooked egg to the edges, 1"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("½")]), _vm._v(" to 2 minutes. Slide the crepe onto the prepared baking sheet. Repeat with the remaining egg mixture, adding more oil to the pan as needed and forming 4 crepes total.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "HeadnoteBox"
  }, [_vm._v("Crepes can be filled with a variety of ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "HeadnoteBox"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Sautéed sausage, shrimp, or scallops")])]), _vm._v(" "), _c('p', {
    staticClass: "HeadnoteBox"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Sliced prosciutto")])]), _vm._v(" "), _c('p', {
    staticClass: "HeadnoteBox"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Shredded Cheddar, fontina, Gruyère, or Manchego cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "HeadnoteBox"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Crumbled feta or soft fresh goat cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "HeadnoteBox"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Sautéed mushrooms with shredded Gruyère cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "HeadnoteBox"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Sautéed halved cherry tomatoes with crumbled feta or goat cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "HeadnoteBox"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Sautéed dark greens with crumbled feta or goat cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "HeadnoteBox"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Sautéed red bell peppers with shredded Manchego cheese")])])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })]), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page39"
    }
  }), _c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p40.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_c('p', {
    staticClass: "pagebreak"
  })]), _c('p', {
    staticClass: "Recipe-Title"
  }, [_c('a', {
    attrs: {
      "id": "page40"
    }
  }), _c('a', {
    attrs: {
      "id": "page41"
    }
  }, [_vm._v("Herbed Egg Crepes with Ricotta and Spring Salad")])]), _c('a', {
    attrs: {
      "id": "page41"
    }
  }, [_c('p', {
    staticClass: "Headnote"
  }, [_vm._v("You can play around with different fillings in this irresistible dish: Prosciutto or smoked salmon are good additions to the ricotta, or replace the ricotta with sautéed mushrooms or greens, or shredded Gruyère.")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Whole-milk ricotta cheese")]), _vm._v(", 1 cup (8 oz/250 g)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Green onions")]), _vm._v(", 3, minced")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Pecorino romano cheese")]), _vm._v(", 3 tablespoons finely grated")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fresh thyme")]), _vm._v(", 2 teaspoons minced")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Olive oil, ¼")]), _vm._v(" cup (2 fl oz/60 ml), plus more as needed")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Kosher salt and freshly ground pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fresh lemon juice")]), _vm._v(", 1 tablespoon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Gluten-free Dijon mustard")]), _vm._v(", 1 teaspoon")])]), _c('p', {
    staticClass: "Ingredients"
  }, [_c('a', {
    attrs: {
      "id": "page41"
    }
  }), _c('a', {
    attrs: {
      "href": "#/cap01#page38"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Herbed Egg Crepes")]), _vm._v(" (see recipe)")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Baby kale or mixed greens")]), _vm._v(", 3 cups (3 oz/90 g)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Radishes")]), _vm._v(", 6, sliced")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Toasted and salted pistachios or toasted almonds or pine nuts, ¼")]), _vm._v(" cup (1 oz/30 g) coarsely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "Serves"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 2 SERVINGS; CAN BE DOUBLED")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colg"
  }, [_vm._v("1")])]), _vm._v("    Preheat the oven to 325°F (165° C). In a medium bowl, mix the ricotta, two-thirds of the green onions, the pecorino cheese, 2 teaspoons thyme, and 1 tablespoon of the oil. Season the filling to taste with salt and pepper. In a small bowl, mix the lemon juice and mustard. Gradually whisk in 3 tablespoons of the oil and the remaining green onions to make a dressing. Season to taste with salt and pepper.")]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colg"
  }, [_vm._v("2")])]), _vm._v("    Spread one-fourth of the ricotta-herb mixture over half of each egg crepe. Fold each crepe in half over the filling, and then fold in half again, forming fan shapes. Place the crepes in the oven and cook until the filling is warm, about 5 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colg"
  }, [_vm._v("3")])]), _vm._v("    Meanwhile, combine the kale and radishes in a salad bowl. Add the dressing and toss to coat. Add the nuts and toss. Season to taste with salt and pepper.")]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colg"
  }, [_vm._v("4")])]), _vm._v("    Arrange 2 filled crepes on each plate. Mound the dressed salad alongside and serve right away.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "HeadnoteBox"
  }, [_vm._v("I discovered packages of mixed baby kale at the grocery store the last time I made this recipe, and it is worth searching out for the salad. Baby greens are very good too.")])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page43"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p43.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page43"
    }
  }, [_c('p', {
    staticClass: "pagebreak"
  })]), _c('p', {
    staticClass: "Recipe-Title"
  }, [_c('a', {
    attrs: {
      "id": "page43"
    }
  }), _c('a', {
    attrs: {
      "id": "page42"
    }
  }, [_vm._v("Grilled Eggplant, Tomatoes, and Goat Cheese")])]), _c('a', {
    attrs: {
      "id": "page42"
    }
  }), _c('p', {
    staticClass: "Headnote"
  }, [_c('a', {
    attrs: {
      "id": "page42"
    }
  }, [_vm._v("Inspired by lasagna, grilled eggplant, ripe tomatoes, and creamy cheese seasoned with fresh basil and balsamic vinegar is a fresh and light vegetarian main dish. ")]), _c('a', {
    attrs: {
      "href": "#/cap01#page26"
    }
  }, [_c('span', {
    staticClass: "colr"
  }, [_vm._v("Wedges of Soft Socca (see recipe)")])]), _vm._v(" are a perfect partner.")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Extra-virgin olive oil")]), _vm._v(", 6 tablespoons")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fresh basil, ¼")]), _vm._v(" cup ("), _c('span', {
    staticClass: "bold"
  }, [_vm._v("⅓")]), _vm._v(" oz/10 g) minced")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Shallots, ¼")]), _vm._v(" cup (1 oz/30 g) minced")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Balsamic vinegar")]), _vm._v(", 2 tablespoons")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Heirloom tomatoes")]), _vm._v(", 10 oz (315 g), cored and chopped (about 1"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("½")]), _vm._v(" cups/280 g)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Kosher salt and freshly ground pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Small, slender Italian eggplants")]), _vm._v(", 4 (about 8 oz/250 g each)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fresh goat cheese, ¾")]), _vm._v(" cup (about 3 oz/90 g) crumbled")]), _vm._v(" "), _c('p', {
    staticClass: "Serves"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 4 SERVINGS")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colb"
  }, [_vm._v("1")])]), _vm._v("    In a small bowl, combine the oil, basil, shallots, and vinegar. In another small bowl, mix the chopped tomatoes and 2 tablespoons of the oil mixture. Season the tomatoes to taste with salt and pepper.")]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colb"
  }, [_vm._v("2")])]), _vm._v("    Trim the rounded part off 2 opposite long sides of each eggplant. Cut the eggplants lengthwise in half and place on a small oiled baking sheet. Brush both sides with the oil mixture and sprinkle lightly with salt and pepper.")]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colb"
  }, [_vm._v("3")])]), _vm._v("    Prepare a grill for direct-heat cooking over high heat. Place the eggplant on the grill. Cover and cook until tender, about 8 minutes per side. Return the eggplant to the baking sheet. Divide the cheese among the eggplant halves. Place the baking sheet on the grill, cover, and cook until the cheese begins to soften, about 3 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colb"
  }, [_vm._v("4")])]), _vm._v("    Using a metal spatula, carefully transfer the topped eggplant to warmed plates. Spoon the tomato mixture over each and serve right away.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "HeadnoteBox"
  }, [_vm._v("Fresh heirloom tomatoes will give the best flavor here. I like Cherokees or Brandywines, but you can choose your favorites.")])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page44"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p44.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page44"
    }
  }, [_c('p', {
    staticClass: "pagebreak"
  })]), _c('p', {
    staticClass: "Recipe-Title"
  }, [_c('a', {
    attrs: {
      "id": "page44"
    }
  }), _c('a', {
    attrs: {
      "id": "page45"
    }
  }, [_vm._v("Macaroni and Cheese with Chard and Sage Bread Crumbs")])]), _c('a', {
    attrs: {
      "id": "page45"
    }
  }, [_c('p', {
    staticClass: "Headnote"
  }, [_vm._v("In this indulgent dish, pure cream plus aged Gruyère and Parmesan cheeses melt to a creamy consistency and stand in for the traditional flour-thickened sauce. Serve this rich dish with a refreshing romaine salad.")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Olive oil")]), _vm._v(", 1"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("½")]), _vm._v(" tablespoons")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Large onion, ½")]), _vm._v(", finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chard, ½")]), _vm._v(" large bunch, stems trimmed, leaves chopped")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Kosher salt and freshly ground pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Heavy cream, ½")]), _vm._v(" cup (4 fl oz/125 ml)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Gluten-free elbow or shell pasta")]), _vm._v(", 8 oz (250 g), (I like Ancient Harvest)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fresh sage")]), _vm._v(", 1 tablespoon minced")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Gluten-free bread")]), _vm._v(", 1 slice, ground to crumbs in a food processor (about "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("½")]), _vm._v(" cup/1 oz/30 g crumbs)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Aged Gruyère cheese")]), _vm._v(", 1 cup (about 3 oz) grated")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Parmesan cheese")]), _vm._v(", 2 tablespoons freshly grated")]), _vm._v(" "), _c('p', {
    staticClass: "Serves"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 4 SERVINGS")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colo"
  }, [_vm._v("1")])]), _vm._v("    In a large nonstick skillet over medium heat, warm 1 tablespoon of the oil. Add the onion and sauté until beginning to soften, about 4 minutes. Add the chard and sprinkle with salt and pepper. Sauté until the chard is tender, about 4 minutes. Stir in the cream and remove from the heat.")]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colo"
  }, [_vm._v("2")])]), _vm._v("    Meanwhile, bring a large pot three-fourths full of salted water to a boil. Add the pasta and stir well. Cook until the pasta is al dente, stirring frequently, about 7 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colo"
  }, [_vm._v("3")])]), _vm._v("    In a small nonstick skillet over medium heat, warm the remaining "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("½")]), _vm._v(" tablespoon oil. Add the sage and stir until fragrant, about 30 seconds. Add the bread crumbs and cook until browned and crisp, stirring frequently, about 4 minutes. Season to taste with salt and pepper.")]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colo"
  }, [_vm._v("4")])]), _vm._v("    Reserve "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("½")]), _vm._v(" cup (4 fl oz/125 ml) of the pasta cooking water. Drain the pasta. Add the pasta to the skillet with the chard. Add both cheeses and stir over medium heat until the cheeses melt and the pasta is coated, thinning with the pasta cooking liquid as needed. Season to taste with salt and a generous amount of pepper. Divide the pasta among 4 warmed plates. Sprinkle with the bread crumbs and serve right away.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "HeadnoteBox"
  }, [_vm._v("My favorite pasta type for this recipe is made from a mixture of quinoa and corn flour.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "HeadnoteBox"
  }, [_vm._v("This is also good made with aged Cheddar cheese, and the chard can be replaced with any type of cooking greens. If you choose kale, you’ll need to sauté it for a few minutes longer than the chard called for here.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "HeadnoteBox"
  }, [_vm._v("Like many people with celiac, I needed to cut down on dairy products at first, but after several months on a gluten-free diet I was able to enjoy cheese again.")])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })]), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page45"
    }
  }), _c('a', {
    attrs: {
      "id": "page47"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p47.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page47"
    }
  }, [_c('p', {
    staticClass: "pagebreak"
  })]), _c('p', {
    staticClass: "Recipe-Title"
  }, [_c('a', {
    attrs: {
      "id": "page47"
    }
  }), _c('a', {
    attrs: {
      "id": "page46"
    }
  }, [_vm._v("White Bean, Kale, and Sage Soup")])]), _c('a', {
    attrs: {
      "id": "page46"
    }
  }), _c('p', {
    staticClass: "Headnote"
  }, [_c('a', {
    attrs: {
      "id": "page46"
    }
  }, [_vm._v("This simple, creamy soup has no trace of cream or flour, but is thickened slightly by starch from the beans and is flavored with earthy sage and spicy pepper flakes. I ")]), _c('span', {
    attrs: {
      "href": "#/cap03#page138",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "colr"
  }, [_vm._v("created Skillet Cornbread (see recipe)")])]), _vm._v(" to serve with it.")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Olive oil")]), _vm._v(", 1 tablespoon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Pancetta")]), _vm._v(", 1"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("½")]), _vm._v(" oz (45 g), chopped (optional)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Large onion")]), _vm._v(", 1, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fresh sage")]), _vm._v(", 1 tablespoon minced")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Red pepper flakes, ¼")]), _vm._v(" teaspoon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Low-sodium, gluten-free vegetable or chicken broth")]), _vm._v(", 4 cups (32 fl oz/1 l)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("White beans")]), _vm._v(", 2 cans (15 oz/470 g each), rinsed and drained")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Kale")]), _vm._v(", 1 large bunch, stems removed, coarsely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Kosher salt and freshly ground black pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "Serves"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 4 SERVINGS")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colg"
  }, [_vm._v("1")])]), _vm._v("    In a large saucepan over medium heat, warm the oil. Add the pancetta, if using, and sauté for 1 minute. Add the onion, sage, and pepper flakes. Sauté until the onion is translucent, about 8 minutes. Add the broth and the beans. Bring to a boil, reduce the heat to low, and simmer for 20 minutes to develop the flavors, stirring occasionally.")]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colg"
  }, [_vm._v("2")])]), _vm._v("    Add the chopped kale and simmer until wilted, about 8 minutes. Thin the soup with water if desired. Season to taste with salt and pepper. Ladle into warmed bowls and serve right away.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "HeadnoteBox"
  }, [_vm._v("If you can’t find low-sodium broth, replace 2 cups (15 fl oz/500 ml) of the broth with 2 cups (15 fl oz/500 ml) water.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "HeadnoteBox"
  }, [_vm._v("Chard is as good as kale in this recipe, and needs only about 3 minutes to wilt into the soup.")])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "Recipe-Title"
  }, [_c('a', {
    attrs: {
      "id": "page48"
    }
  }, [_vm._v("Indian-Style Chickpea Salad")])]), _c('a', {
    attrs: {
      "id": "page48"
    }
  }, [_c('p', {
    staticClass: "Headnote"
  }, [_vm._v("I created this moderately spiced salad for my cousin’s potluck wedding rehearsal dinner, and received many requests for the recipe. It is a good dish to bring to parties, to be certain there is gluten-free food available.")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Olive oil")]), _vm._v(", 2 tablespoons")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Green onions")]), _vm._v(", 2 bunches, thinly sliced")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fresh ginger")]), _vm._v(", 1 tablespoon minced")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Serrano chile")]), _vm._v(", 1, minced with seeds")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fresh cilantro, ½")]), _vm._v(" cup ("), _c('span', {
    staticClass: "bold"
  }, [_vm._v("¾")]), _vm._v(" oz/20 g) chopped")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ground coriander")]), _vm._v(", 1"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("½")]), _vm._v(" teaspoons")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chickpeas")]), _vm._v(", 2 cans (15.5 oz/485 g each) rinsed and drained")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Pomegranate molasses")]), _vm._v(", 2 tablespoons")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Tomato")]), _vm._v(", 1 large, seeded and chopped")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Persian cucumbers")]), _vm._v(", 2 chopped")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Plain yogurt, ½")]), _vm._v(" cup (4 oz/125 g)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ground cumin, ¼")]), _vm._v(" teaspoon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Kosher salt and freshly ground pepper")])])]), _c('p', {
    staticClass: "Ingredients"
  }, [_c('a', {
    attrs: {
      "id": "page48"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Romaine heart leaves, warmed gluten-free tortillas, or wedges of Soft")])]), _c('a', {
    attrs: {
      "href": "#/cap01#page26"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Socca")]), _vm._v(" (see recipe)")]), _vm._v(", for serving")]), _vm._v(" "), _c('p', {
    staticClass: "Serves"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 4 SERVINGS")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colb"
  }, [_vm._v("1")])]), _vm._v("    In a large nonstick frying pan over medium-high heat, warm the oil. Add half of the green onions, the ginger, and chile and sauté until tender, about 1 minute. Add "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("¼")]), _vm._v(" cup ("), _c('span', {
    staticClass: "bold"
  }, [_vm._v("⅓")]), _vm._v(" oz/10 g) of the cilantro and the coriander and stir until fragrant, about 30 seconds. Stir in the chickpeas, pomegranate molasses, and "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("¼")]), _vm._v(" cup (2 fl oz/60 ml) water. Simmer until the beans are tender and the liquid is absorbed, about 5 minutes. Let cool slightly.")]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colb"
  }, [_vm._v("2")])]), _vm._v("    Meanwhile, in a large bowl, combine the tomato, cucumber, remaining green onions, and remaining "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("¼")]), _vm._v(" cup ("), _c('span', {
    staticClass: "bold"
  }, [_vm._v("⅓")]), _vm._v(" oz/10 g) cilantro. In a small bowl, mix together the yogurt and cumin; season to taste with salt.")]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colb"
  }, [_vm._v("3")])]), _vm._v("    Stir the chickpea mixture into the tomato mixture. Season to taste with salt and black pepper. Divide the salad among 4 plates. Serve with the yogurt sauce, romaine, tortillas, or socca for scooping.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "HeadnoteBox"
  }, [_vm._v("I like to keep pomegranate molasses, made from pomegranate juice that has been boiled until syrupy, in the cupboard to add an exciting sweet-tart taste to salads, sauces, and stewed dishes.")])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "Recipe-Title"
  }, [_c('a', {
    attrs: {
      "id": "page49"
    }
  }, [_vm._v("Spaghetti with Heirloom Tomatoes, Olives, and Herbs")])]), _c('a', {
    attrs: {
      "id": "page49"
    }
  }, [_c('p', {
    staticClass: "Headnote"
  }, [_vm._v("When this uncooked tomato sauce hits the hot pasta, it creates an explosion of summery flavor and fragrance. Use your favorite heirloom varieties, like purple Cherokees, Brandywine, and Sungold cherry tomatoes.")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ripe heirloom tomatoes")]), _vm._v(", 1 lb (500 g), cored, halved, seeded, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Heirloom cherry tomatoes")]), _vm._v(", such as Sungold, 1 cup (6 oz/185 g), halved")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Mixed fresh herbs, ¼")]), _vm._v(" cup ("), _c('span', {
    staticClass: "bold"
  }, [_vm._v("⅓")]), _vm._v(" oz/10 g) chopped")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Pitted Kalamata olives")]), _vm._v(", 3 tablespoons chopped")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Extra-virgin olive oil")]), _vm._v(", 2 tablespoons")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Shallot")]), _vm._v(", 1"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("½")]), _vm._v(" tablespoons minced")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Balsamic vinegar")]), _vm._v(", 2 teaspoons")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Kosher salt and freshly ground pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Gluten-free spaghetti")]), _vm._v(", 6 oz (185 g)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Feta cheese, ⅓")]), _vm._v(" cup crumbled (about 2 oz/60 g)")]), _vm._v(" "), _c('p', {
    staticClass: "Serves"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 2 SERVINGS; CAN BE DOUBLED")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colb"
  }, [_vm._v("1")])]), _vm._v("    In a medium bowl, mix the tomatoes, cherry tomatoes, herbs, olives, oil, shallot, and vinegar. Season to taste with salt and pepper.")]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colb"
  }, [_vm._v("2")])]), _vm._v("    Add the pasta to a large pot of salted water, and stir well. Cook, stirring frequently, until al dente, about 8 minutes. Drain well and place in a warmed pasta bowl. Add the tomato mixture and toss to combine. Gently mix in the cheese. Season to taste and serve right away on 2 warmed plates.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "HeadnoteBox"
  }, [_vm._v("A young goat cheese is a fresh-tasting alternative to feta. For the herbs, basil, mint, marjoram, thyme, and tarragon are all good choices, in any combination.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "HeadnoteBox"
  }, [_vm._v("Pasta made with corn and quinoa flour works well in this recipe.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "HeadnoteBox"
  }, [_vm._v("I like to make a double recipe and then enjoy leftovers as a cold dish the next day.")])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })]), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page49"
    }
  }), _c('a', {
    attrs: {
      "id": "page50"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p50-51.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page50"
    }
  }, [_c('p', {
    staticClass: "pagebreak"
  })]), _c('p', {
    staticClass: "Recipe-Title"
  }, [_c('a', {
    attrs: {
      "id": "page50"
    }
  }), _c('a', {
    attrs: {
      "id": "page51"
    }
  }, [_vm._v("Polenta Pizza Crust")])]), _c('a', {
    attrs: {
      "id": "page51"
    }
  }, [_c('p', {
    staticClass: "Headnote"
  }, [_vm._v("Pizza need not be off-limits if you are living a gluten-free lifestyle. There are many gluten-free pizza crusts available today that are perfect for quick weekday meals, but I enjoy making pizza crusts from polenta, as I like the texture and flavor that it contributes. There’s no need to wait for the crust to rise, as with yeast-risen wheat-flour bases, and it is a surprising dish to serve to company. The crust will not be firm enough to pick up, but, enjoyed with a fork, it has the same satisfaction of wheat-flour pizza.")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Gluten-free medium-grind cornmeal")]), _vm._v(" (I like Bob’s Red Mill), 1"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("⅓")]), _vm._v(" cups (7 oz/220 g)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Kosher salt and freshly ground pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Olive oil")]), _vm._v(", 1"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("½")]), _vm._v(" tablespoons, plus more as needed")])]), _c('p', {
    staticClass: "Ingredients"
  }, [_c('a', {
    attrs: {
      "id": "page51"
    }
  }), _c('a', {
    attrs: {
      "href": "#/cap01#page52"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Toppings of your choice")]), _vm._v(" (see see recipe")]), _vm._v(" for ideas)")]), _vm._v(" "), _c('p', {
    staticClass: "start2"
  }), _vm._v(" "), _c('p', {
    staticClass: "method1"
  }, [_vm._v("In a microwave-safe bowl, mix 4 cups (32 fl oz/1 l) water, the cornmeal, and 1"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("¾")]), _vm._v(" teaspoons salt. Place in the microwave and cook at the high setting for 5 minutes. Stir thoroughly, then return to the microwave and cook at the high setting for 5 more minutes. Stir well. Return to the microwave and cook at the high setting until very thick, about 5 minutes longer. Stir again, and then mix in the 1"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("½")]), _vm._v(" tablespoons olive oil and a generous amount of pepper.")]), _vm._v(" "), _c('p', {
    staticClass: "method1"
  }, [_vm._v("Brush a large pizza pan generously with olive oil. (Do not line the pan with parchment, or the crust will not gain the desired texture.) Spread the cornmeal mixture out on the pan in a circle about "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("⅓")]), _vm._v(" inch (9 mm) thick and about 12 inches (30 cm) in diameter, building up the edges slightly.")]), _vm._v(" "), _c('p', {
    staticClass: "method1"
  }, [_vm._v("To bake, preheat the oven to 375°F (190°C). Spread tomato sauce, if using, over the cornmeal crust, leaving a border, then layer on the desired toppings. Bake the pizza until it is beginning to brown in spots, about 20 minutes. Let stand for 5 minutes to set up.")]), _vm._v(" "), _c('p', {
    staticClass: "method1"
  }, [_vm._v("Sprinkle the top of the finished pizza with chopped fresh herbs, if desired, then cut into wedges and serve right away.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page53"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p53.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page53"
    }
  }, [_c('p', {
    staticClass: "pagebreak"
  })]), _c('p', {
    staticClass: "Recipe-Title"
  }, [_c('a', {
    attrs: {
      "id": "page53"
    }
  }), _c('a', {
    attrs: {
      "id": "page52"
    }
  }, [_vm._v("Polenta Pizza with Tomatoes and Fresh Herbs")])]), _c('a', {
    attrs: {
      "id": "page52"
    }
  }, [_c('p', {
    staticClass: "Headnote"
  }, [_vm._v("Gooey cheese melting into baked polenta—crisp on the outside with a creamy interior—is as satisfying as a pizza, but is definitely its own creation. In my house, this one is our new favorite take on the Margherita.")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fresh mozzarella cheese, ½")]), _vm._v(" lb (250 g) coarsely grated")])]), _c('p', {
    staticClass: "Ingredients"
  }, [_c('a', {
    attrs: {
      "id": "page52"
    }
  }), _c('a', {
    attrs: {
      "href": "#/cap01#page51"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Polenta Pizza Crust")]), _vm._v(" (see recipe)")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Small cherry tomatoes or grape tomatoes")]), _vm._v(", 1"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("⅓")]), _vm._v(" cups (8 oz/250 g), halved")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Shallot")]), _vm._v(", 2 tablespoons minced, or 2 cloves garlic, minced")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Olive oil")]), _vm._v(", 1"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("½")]), _vm._v(" tablespoons, plus more as needed")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Balsamic vinegar")]), _vm._v(", 1"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("½")]), _vm._v(" teaspoons")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Kosher salt and freshly ground pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Parmesan cheese, ⅓")]), _vm._v(" cup (1"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("½")]), _vm._v(" oz/45 g) freshly grated")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fresh basil, ¼")]), _vm._v(" cup ("), _c('span', {
    staticClass: "bold"
  }, [_vm._v("⅓")]), _vm._v(" oz/10 g) sliced, or 3 tablespoons chopped fresh marjoram")]), _vm._v(" "), _c('p', {
    staticClass: "Serves"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 4 SERVINGS")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colg"
  }, [_vm._v("1")])]), _vm._v("    Preheat the oven to 375°F (190°C). Sprinkle the mozzarella cheese over the pizza crust on the pizza pan, leaving a border.")]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colg"
  }, [_vm._v("2")])]), _vm._v("    In a small bowl, mix the tomatoes, shallot, 1"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("½")]), _vm._v(" tablespoons oil, and the vinegar. Season to taste with salt and pepper. Spoon the tomato mixture over the cheese. Sprinkle with the Parmesan cheese.")]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colg"
  }, [_vm._v("3")])]), _vm._v("    Bake the pizza until it is beginning to brown in spots, about 20 minutes. Let stand for 5 minutes to set up. Sprinkle with the herbs and serve right away with forks and knives for eating.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "HeadnoteBox"
  }, [_vm._v("For a novel approach to pizza, toss baby arugula with olive oil and lemon and mound it atop fontina or mozzarella cheese melted on the finished crust.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "HeadnoteBox"
  }, [_vm._v("More of my favorite toppings for polenta pizza include mozzarella, fontina, feta, or goat cheese; tomato sauce; sautéed mushrooms, bell peppers, onions, or zucchini; gluten-free sausage or pepperoni; pitted olives; halved cherry tomatoes; or chopped fresh herbs.")])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page54"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p54.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page54"
    }
  }, [_c('p', {
    staticClass: "pagebreak"
  })]), _c('p', {
    staticClass: "Recipe-Title"
  }, [_c('a', {
    attrs: {
      "id": "page54"
    }
  }), _c('a', {
    attrs: {
      "id": "page55"
    }
  }, [_vm._v("Quinoa Tabbouleh")])]), _c('a', {
    attrs: {
      "id": "page55"
    }
  }, [_c('p', {
    staticClass: "Headnote"
  }, [_vm._v("Here I transform one of my favorite wheat-based dishes into a gluten-free version by substituting high-protein quinoa for bulgur. This recipe gets a flavor boost from feta cheese, fresh mint, and lemon juice.")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Quinoa")]), _vm._v(", 1 cup (6 oz/185 g), preferably multi-color")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Kosher salt and freshly ground pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cherry tomatoes")]), _vm._v(", preferably heirloom, 1 lb (500 g), halved")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chickpeas")]), _vm._v(", 1 can (15 oz/470 g), rinsed and well drained")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Radishes")]), _vm._v(", 6, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Persian cucumbers")]), _vm._v(", 3, trimmed, quartered lengthwise, cut into "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("½")]), _vm._v("-inch (12 mm) pieces")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Green onions")]), _vm._v(", 4, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fresh flat-leaf parsley, ¾")]), _vm._v(" cup (1 oz/30 g) chopped")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fresh mint")]), _vm._v(", 3 tablespoons minced")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Feta cheese, ½")]), _vm._v(" cup (2"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("½")]), _vm._v(" oz/75 g) crumbled (optional)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Extra-virgin olive oil, ¼")]), _vm._v(" cup (2 fl oz/60 ml)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fresh lemon juice, ¼")]), _vm._v(" cup (2 fl oz/60 ml)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Romaine hearts")])]), _vm._v(" "), _c('p', {
    staticClass: "Serves"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 4 SERVINGS")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colo"
  }, [_vm._v("1")])]), _vm._v("    Place the quinoa in a medium saucepan. Rinse with cold water, drain. Repeat rinsing 3 more times, and then drain the quinoa and return to the pan. Add 1"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("½")]), _vm._v(" cups (12 fl oz/375 ml) water and a pinch of salt and bring to a boil. Reduce the heat to low, cover, and simmer until all the water is absorbed, about 15 minutes. Turn off the heat and let stand at least 5 minutes. Fluff with a fork. Transfer the quinoa to a large shallow bowl and cool to room temperature. (Refrigerate to speed up the cooling).")]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colo"
  }, [_vm._v("2")])]), _vm._v("    Meanwhile, in a medium bowl, combine the tomatoes, chickpeas, radishes, cucumbers, green onions, parsley, mint, and feta, if using. Add to the cooled quinoa. Add the oil and lemon juice and toss to combine evenly. Season to taste with salt and pepper. Serve with romaine hearts for scooping.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "HeadnoteBox"
  }, [_vm._v("To speed up dinner prep during the week, cook the quinoa the evening before (or save the leftovers from dinner that night).")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "HeadnoteBox"
  }, [_vm._v("Instead of the cherry tomatoes, you can use 1 lb (500 g) regular heirloom tomatoes, seeded and chopped.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "HeadnoteBox"
  }, [_vm._v("I like to spoon the salad into a bowl lined with romaine hearts, and then use the salad to pick up bite-sized portions. This is another convenient dish to take to parties.")])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })]), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page55"
    }
  }), _c('a', {
    attrs: {
      "id": "page57"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p57.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page57"
    }
  }, [_c('p', {
    staticClass: "pagebreak"
  })]), _c('p', {
    staticClass: "Recipe-Title"
  }, [_c('a', {
    attrs: {
      "id": "page57"
    }
  }), _c('a', {
    attrs: {
      "id": "page56"
    }
  }, [_vm._v("Potato Pancakes, Poached Eggs, and Green Onion Sauce")])]), _c('a', {
    attrs: {
      "id": "page56"
    }
  }, [_c('p', {
    staticClass: "Headnote"
  }, [_vm._v("Golden brown and crisp rosti-style potato pancakes make an ideal base for poached eggs. For best results, use your favorite extra-virgin olive oil for the vibrant green onion and parsley sauce.")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Extra-virgin olive oil, ¼")]), _vm._v(" cup (2 fl oz/60 ml) plus 2 tablespoons, plus more as needed")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fresh flat-leaf parsley")]), _vm._v(", 5 tablespoons (1 oz/30 g) minced")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Green onions")]), _vm._v(", 2 tablespoons minced green tops and 3 tablespoons minced white parts")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Kosher salt and freshly ground pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Russet potatoes")]), _vm._v(", 1 lb (500 g), peeled")])]), _c('p', {
    staticClass: "Ingredients"
  }, [_c('a', {
    attrs: {
      "id": "page56"
    }
  }), _c('a', {
    attrs: {
      "href": "#/cap01#page16"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Poached Eggs")]), _vm._v(", 4 (see recipe)")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Plain Greek-style yogurt for serving")])]), _vm._v(" "), _c('p', {
    staticClass: "Serves"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAKES 2 SERVINGS; CAN BE DOUBLED")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colb"
  }, [_vm._v("1")])]), _vm._v("    Preheat the oven to 450°F (230°C). Meanwhile, in a small bowl, mix "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("¼")]), _vm._v(" cup (2 fl oz/60 ml) of the oil, 2 tablespoons of the parsley, the green onion tops, and "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("¼")]), _vm._v(" teaspoon salt to make a sauce.")]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colb"
  }, [_vm._v("2")])]), _vm._v("    In a food processor fitted with the coarse grating blade, grate the potatoes. Transfer to a bowl and mix in the remaining 3 tablespoons parsley and the white green onion parts.")]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colb"
  }, [_vm._v("3")])]), _vm._v("    Working quickly, warm 2 tablespoons oil in a 12-inch (30-cm) nonstick frying pan over medium-high heat. Add about "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("½")]), _vm._v(" cup (3 oz/90 g) of the potato mixture to the pan and flatten with the back of a spatula into a thin pancake. Repeat, forming 3 more pancakes. Cook until brown and crisp on the first side, about 6 minutes. Sprinkle with salt and pepper, turn over, and cook until brown and crisp on the second side, about 6 minutes. Transfer the potato pancakes to paper towels to drain. Add more oil to the pan and repeat, forming more pancakes. Transfer to paper towels to drain. Transfer the potato pancakes to a baking sheet. Reheat the pancakes in the oven while you poach the eggs.")]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_c('span', {
    staticClass: "big-no"
  }, [_c('span', {
    staticClass: "colb"
  }, [_vm._v("4")])]), _vm._v("    Place 2 potato pancakes on each of 2 warmed plates. Top with the eggs and spoon the green onion sauce over the top. Serve right away with the yogurt and any remaining pancakes on the side.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "HeadnoteBox"
  }, [_vm._v("Place peeled potatoes in water to cover to keep them from turning brown as you work.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "HeadnoteBox"
  }, [_vm._v("The pancakes can be made ahead and reheated in a 450°F (230°C) oven until warm throughout and crisp, about 5 minutes")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-833b135e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cap01.vue
// module id = 72
// module chunks = 0